import { ADMIN_PROSPECT_STATUSES } from '../../services/admin/prospectsListRequest.js';

export const ADMIN_PROSPECT_PUBLIC_RESPONSE_ANCHOR = 'prospect-public-response';

/**
 * Quick-action statuses. Never offer converting via this panel (lot 3).
 * Preserve an already-converted record by still listing `converted` when current.
 * @param {string | null | undefined} currentStatus
 */
export function adminProspectQuickFollowUpStatusOptions(currentStatus) {
  return ADMIN_PROSPECT_STATUSES.filter(
    (status) => status !== 'converted' || currentStatus === 'converted',
  );
}

/**
 * Parse a datetime-local value without treating invalid input as a clear.
 * @param {unknown} value
 * @returns {{ ok: true, iso: string | null, empty: boolean } | { ok: false, iso: null, empty: false }}
 */
export function parseAdminProspectDatetimeLocal(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return { ok: true, iso: null, empty: true };
  const date = new Date(raw);
  if (Number.isNaN(date.getTime()) || date.getTime() === 0) {
    return { ok: false, iso: null, empty: false };
  }
  return { ok: true, iso: date.toISOString(), empty: false };
}

/**
 * Browser IANA timezone for follow-up scheduling copy.
 * @param {typeof Intl} [intl]
 */
export function adminProspectFollowUpTimeZoneLabel(intl = Intl) {
  try {
    return new intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}

/**
 * Whether a delayed async result may still mutate this panel's UI.
 * @param {{ ownerProspectId: string, activeProspectId: string, mounted?: boolean }} args
 */
export function shouldApplyAdminProspectQuickFollowUpResult({
  ownerProspectId,
  activeProspectId,
  mounted = true,
}) {
  if (!mounted) return false;
  const owner = String(ownerProspectId || '').trim();
  const active = String(activeProspectId || '').trim();
  return Boolean(owner) && owner === active;
}
